export default "__VITE_ASSET__Bl1rR4xn__"